// Attendance.jsx
import { useEffect, useState } from 'react';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

export default function Attendance() {
  const { user } = useAuth();
  const [records, setRecords] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);

  const load = () => {
    const now = new Date();
    api.get('/attendance', { params: { month: now.getMonth()+1, year: now.getFullYear() } })
      .then(r => { setRecords(r.data.data.records); setSummary(r.data.data.summary); })
      .catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const checkIn  = async () => { setActionLoading(true); try { await api.post('/attendance/check-in');  load(); } catch(e){ alert(e.response?.data?.message); } finally { setActionLoading(false); } };
  const checkOut = async () => { setActionLoading(true); try { await api.patch('/attendance/check-out'); load(); } catch(e){ alert(e.response?.data?.message); } finally { setActionLoading(false); } };

  const statusColors = { present:'active', absent:'danger', half_day:'pending', work_from_home:'completed', on_leave:'inactive' };

  return (
    <div className="slide-up">
      <div className="page-header">
        <div className="page-header-left"><h1>Attendance</h1><p>This month's attendance records</p></div>
        <div style={{ display:'flex', gap:'0.75rem' }}>
          <button className="btn btn-primary" onClick={checkIn} disabled={actionLoading}>Check In</button>
          <button className="btn btn-secondary" onClick={checkOut} disabled={actionLoading}>Check Out</button>
        </div>
      </div>
      <div className="stats-grid" style={{ marginBottom:'1.5rem' }}>
        {[['Present', summary.present], ['Absent', summary.absent], ['Half Day', summary.halfDay], ['WFH', summary.wfh]].map(([l,v]) => (
          <div className="stat-card" key={l}><div className="stat-num">{v ?? 0}</div><div className="stat-label">{l}</div></div>
        ))}
      </div>
      <div className="card" style={{ padding:0 }}>
        {loading ? <div style={{ textAlign:'center', padding:'3rem' }}><div className="spinner spinner-lg" /></div> :
         records.length === 0 ? <div className="empty-state"><h3>No records this month</h3></div> : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Employee</th><th>Date</th><th>Check In</th><th>Check Out</th><th>Hours</th><th>Status</th></tr></thead>
              <tbody>
                {records.map(r => (
                  <tr key={r._id}>
                    <td><strong>{r.employee?.name}</strong></td>
                    <td>{new Date(r.date).toLocaleDateString('en-IN')}</td>
                    <td>{r.checkIn ? new Date(r.checkIn).toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit' }) : '—'}</td>
                    <td>{r.checkOut ? new Date(r.checkOut).toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit' }) : '—'}</td>
                    <td>{r.hoursWorked || '—'}</td>
                    <td><span className={`badge badge-${statusColors[r.status] || 'inactive'}`}>{r.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}